module.exports = __webpack_public_path__ + "static/media/01C.34ede2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/01C.png
// module id = 276
// module chunks = 0